<template>
    <div id="location-share">
        <a-modal :visible="showMap" centered hide-header :footer="null" @cancel="showMap = false">
            <l-map ref="map" @ready="ready" :center="center" :zoom="zoom" class="map" @click="mapClick">
                <l-tile-layer :url="url" />
                <l-marker draggable :icon="icons.default" :lat-lng.sync="center" />
            </l-map>
            <div class="btn mt-3 pointer" @click="getCurrentLocation" :class="{ disabled: !locationEnabled }">
                <md-icon>my_location</md-icon>
                <span>{{ $t("message.useMyLocation") }}</span>
                <div class="text-danger" v-if="!locationEnabled">({{ $t("message.locationPermsNeeded") }})</div>
            </div>
            <div class="d-flex w-100 justify-content-center content-button">
                <a-button class="mr-3 btn-success d-block text-light" type="primary" @click="sendLocation"
                    >{{ $t("message.send") }}
                </a-button>
                <a-button class="secondary btn-form" @click="cancel">
                    {{ $t("message.cancel") }}
                </a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import L from "leaflet";
import { sendSocketMessage } from "../../utils/socketStream";
import log2 from "../../utils/log2";
import _ from "lodash";

const log = log2("LocationShare.vue");

export default {
    name: "LocationShare",
    props: {
        isLocationClick: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            zoom: 15,
            center: { lat: 41.02964338716641, lng: 29.00115966796875 },
            showMap: false,
            icons: {
                default: L.icon({
                    iconUrl: "https://img.icons8.com/ios-glyphs/30/undefined/marker--v1.png",
                    iconSize: [34, 34],
                    iconAnchor: [17, 17],
                }),
            },
            locationEnabled: true,
        };
    },
    computed: {
        ...mapState({
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.conversationId,
            siteId: (state) => state.site.site._id,
            visitorGeoLocation: (state) => _.get(state.chat.visitorInfo, "geolocation.ll", null),
        }),
    },
    methods: {
        log,
        ready() {
            log(this.$refs.map);
            if (!!this.$refs.map) {
                setTimeout(() => {
                    this.$refs.map.mapObject["invalidateSize"]();
                }, 300);
            }
        },
        userLocation({ coords }) {
            log(coords);
            this.center = { lat: coords.latitude, lng: coords.longitude };
        },
        mapClick({ latlng, ...rest }) {
            log(latlng, rest);
            this.center = { lat: latlng.lat, lng: latlng.lng };
        },
        sendLocation() {
            log("sendLocation");
            this.showMap = false;
            sendSocketMessage("visitor location message", {
                conversationId: this.conversationId,
                visitorId: this.visitorId,
                siteId: this.siteId,
                location: this.center,
            });
        },
        cancel(){
            this.showMap = false;
        },
        getCurrentLocation() {
            if (!!navigator.geolocation && !!navigator.geolocation.getCurrentPosition)
                navigator.geolocation.getCurrentPosition(this.userLocation.bind(this), () => {
                    this.locationEnabled = false;
                });
        },
    },
    async mounted() {
        log("mounted");
        if (!!navigator.permissions) {
            const permission = await navigator.permissions.query({ name: "geolocation" });
            this.locationEnabled = !(permission.state === "denied");
        }
        if (!!this.visitorGeoLocation)
            this.center = {
                lat: this.visitorGeoLocation[0],
                lng: this.visitorGeoLocation[1],
            };
    },
    watch: {
        showMap(val) {
            if (val) this.getCurrentLocation();
        },
        visitorGeoLocation() {
            if (!!this.visitorGeoLocation)
                this.center = {
                    lat: this.visitorGeoLocation[0],
                    lng: this.visitorGeoLocation[1],
                };
        },
        isLocationClick(newVal, oldVal) {
            if (newVal === true) {
                this.showMap = true;
                this.$emit("onLocationClicked", false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#location-share {
    .csbtn {
        cursor: pointer;
    }
}

.map {
    height: 300px;
    border-radius: var(--sps-radius-sm);
    overflow: hidden;
}
.btnSendLocation {
    background: var(--chat-bubble-background) !important;
    color: var(--chat-bubble-text) !important;
    border-color: var(--chat-bubble-system-background) !important;
}
</style>
<style lang="scss">
.btnSendLocation {
    background: var(--chat-bubble-background) !important;
    color: var(--chat-bubble-text) !important;
    border-color: var(--chat-bubble-system-background) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/LocationShare.vue